class UpgradeLogsRequest {
    static logsReadRequest = {
        readAll: "YES"

    }
    static logsApproveRequest = {
        username: null,
        type: null
    }
    static logsDeclineRequest = {
        username: null,
        type: null,
        comment: null
    }

}
export default UpgradeLogsRequest

